export const searchDropdownDivId = 'search-dropdown';
